module.exports = __webpack_public_path__ + "e4b1948a6714be84166af66cbe7fa6ec.png";